import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import { CheckboxInput, TextInput } from '../../../../shared/FormBuilder'

function Genitourinary () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-3'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.genitourinaryDeferred}
          />
        </div>
        <div className='col-xs-12 margin-top'>
          <CheckboxInput
            className='nh-checkbox'
            {...PEQuestionnaire.genitourinaryOther}
          />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.genitourinaryOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Genitourinary
